import IService from '../IService';

const defaultsFonts = [
  {
    friendlyName: 'OpenSans',
    fontFamily: 'OpenSans-Regular',
    srcUrl: '/resources/css/fonts/OpenSans-Regular.woff',
    format: 'woff',
    fontWeight: 'normal',
    fontStyle: 'normal',
    unicodeRange: 'UTF-8',
  },
  {
    friendlyName: 'Roboto',
    fontFamily: 'Roboto-Regular',
    srcUrl: '/resources/css/fonts/Roboto-Regular.woff',
    format: 'woff',
    fontWeight: 'normal',
    fontStyle: 'normal',
    unicodeRange: 'UTF-8',
  },
  {
    friendlyName: 'Lato',
    fontFamily: 'Lato-Regular',
    srcUrl: '/resources/css/fonts/Lato-Regular.woff',
    format: 'woff',
    fontWeight: 'normal',
    fontStyle: 'normal',
    unicodeRange: 'UTF-8',
  },
  {
    friendlyName: 'Aleo',
    fontFamily: 'Aleo-Regular',
    srcUrl: '/resources/css/fonts/Aleo-Regular.woff',
    format: 'woff',
    fontWeight: 'normal',
    fontStyle: 'normal',
    unicodeRange: 'UTF-8',
  },
  {
    friendlyName: 'Neris',
    fontFamily: 'Neris-Regular',
    srcUrl: '/resources/css/fonts/Neris-Regular.woff',
    format: 'woff',
    fontWeight: 'normal',
    fontStyle: 'normal',
    unicodeRange: 'UTF-8',
  },
];

export default IService.extend({
  get: function (data) {
    const deferred = $.Deferred();
    this.promise = deferred.promise();

    if (!data || !data.containDefaultFonts || !data.programmerId) {
      console.error('fonts: insufficient data', data);
    }

    if (this._cachedResponse) {
      deferred.resolve(this._cachedResponse);
    } else {
      this.$ajax = $.ajax({
        url: app.apiUrl('/api/v1/users/me/fonts'),
        type: 'GET',
        dataType: 'json',
        context: this,
        data: {
          programmerId: data.programmerId,
          containDefaultFonts: data.containDefaultFonts,
        },
        error: function (jqXHR, textStatus) {
          if (textStatus === 'abort') {
            deferred.reject(textStatus);
          } else {
            console.error('fonts: error getting data for user');
            deferred.resolve(defaultsFonts);
          }
        },
        success: function (response) {
          if (!_.isEmpty(response) && _.isObject(response)) {
            if (_.isArray(response)) {
              this._cachedResponse = response.slice();
            } else if (_.isObject(response)) {
              this._cachedResponse = $.extend(
                true,
                { isCache: true },
                response
              );
            } else {
              this._cachedResponse = response;
            }

            deferred.resolve(response);
          } else {
            app.doctorController.report('Invalid response in fonts.js');
            deferred.reject(response);
          }
        }.bind(this),
      }).always(() => {
        this.$ajax = null;
      });
    }

    return this.promise;
  },

  clearCache: function () {
    this._cachedResponse = null;
    return this;
  },

  abort: function () {
    if (app.xhrExpected(this.$ajax)) {
      this.$ajax.abort();
    }
    return this;
  },
});
